// extracted by mini-css-extract-plugin
export default {"column":"ReportFilter_column__GIy0R","placeHolderShimmer":"ReportFilter_placeHolderShimmer__nzpN7"};